"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonProps = exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _buttonsModule = _interopRequireDefault(require("../../tools/buttons.module.scss"));

var _spinner = _interopRequireDefault(require("../spinner"));

var _excluded = ["loading", "disabled", "type", "className", "buttonType", "ariaLabel", "id", "dataTestId", "ariaPressed", "onClick", "children", "forwardedRef"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function dashToCamelCase(string) {
  var str = string.replace(/-([a-z])/g, function (g) {
    return g[1].toUpperCase();
  });
  return str.charAt(0).toUpperCase() + str.slice(1);
}

var Button = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Button, _Component);

  var _super = _createSuper(Button);

  function Button() {
    (0, _classCallCheck2.default)(this, Button);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(Button, [{
    key: "className",
    value: function className(type) {
      var disabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return _buttonsModule.default["Button".concat(dashToCamelCase(type)).concat(disabled ? 'Disabled' : '')];
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          loading = _this$props.loading,
          disabled = _this$props.disabled,
          type = _this$props.type,
          className = _this$props.className,
          buttonType = _this$props.buttonType,
          ariaLabel = _this$props.ariaLabel,
          id = _this$props.id,
          dataTestId = _this$props.dataTestId,
          ariaPressed = _this$props.ariaPressed,
          onClick = _this$props.onClick,
          children = _this$props.children,
          forwardedRef = _this$props.forwardedRef,
          props = (0, _objectWithoutProperties2.default)(_this$props, _excluded); // Always disabled when loading

      var isDisabled = loading || disabled;
      var classNames = (0, _classnames.default)(this.className(type, isDisabled), className);
      var attributes = {};

      if (isDisabled) {
        attributes.disabled = 'disabled';
      }

      if (buttonType) {
        attributes.type = buttonType;
      }

      return /*#__PURE__*/_react.default.createElement("button", (0, _extends2.default)({
        onClick: onClick,
        className: classNames,
        "aria-label": ariaLabel,
        id: id,
        "data-test-id": dataTestId,
        "aria-pressed": ariaPressed,
        ref: forwardedRef
      }, attributes, props), loading ? /*#__PURE__*/_react.default.createElement(_spinner.default, {
        className: _buttonsModule.default.Spinner
      }) : /*#__PURE__*/_react.default.createElement("span", {
        className: _buttonsModule.default.text
      }, children));
    }
  }]);
  return Button;
}(_react.Component);

exports.default = Button;
var ButtonProps = {
  type: _propTypes.default.oneOf(['primary', 'secondary', 'secondary-light', 'tertiary', 'tertiary-light', 'inferior']),
  disabled: _propTypes.default.bool,
  loading: _propTypes.default.bool,
  children: _propTypes.default.node,
  className: _propTypes.default.string,
  onClick: _propTypes.default.func,
  buttonType: _propTypes.default.oneOf(['submit', 'reset', 'button']),
  ariaLabel: _propTypes.default.string,
  ariaPressed: _propTypes.default.bool,
  id: _propTypes.default.string,
  dataTestId: _propTypes.default.string,
  forwardedRef: _propTypes.default.string
};
exports.ButtonProps = ButtonProps;
Button.propTypes = ButtonProps;
Button.defaultProps = {
  type: 'primary',
  loading: false,
  disabled: false
};